import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ApiHttp } from 'app/providers';

@Injectable()
export class XpressPaymentTransactionService {
    constructor(private apiHttp: ApiHttp) {}

    public getTransactionsByMerchantAdmin(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressPaymentTransaction/GetTransactionsByMerchant', data, messageService);
    }

    public getTransactionByIdAdmin(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressPaymentTransaction/GetTransactionById', data, messageService);
    }

    public getInOutTransactions(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressPaymentTransaction/GetInOutTransactions', data, messageService);
    }

    public downloadInOutTransactions(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.postDownloadFile('api/AdminXpressPaymentTransaction/DownloadInOutTransactions', data, messageService);
    }

    public freezeTransaction(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressPaymentTransaction/FreezeTransaction', data, messageService);
    }

    public releaseHold(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressPaymentTransaction/ReleaseHold', data, messageService);
    }

    public reverseHold(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressPaymentTransaction/ReverseHold', data, messageService);
    }
}
